import { Skeleton } from './styled';
import { SkeletonLoaderProps } from './types';

export type { SkeletonLoaderProps } from './types';

export const SkeletonLoader = (props: SkeletonLoaderProps) => <Skeleton aria-hidden {...props} />;
